export const countAttempts = 3;
export const translationKeys = {
  attempts: ['recovery.verification.attempts.exist', 'Invalid verification code. <br/> Remaining attempts: {{count}}'],
  attemptsFinish: ['recovery.verification.attempts.finish', 'Attempts to enter the code have been exhausted. <br/> Request a new one.']
};